
import React from 'react'
import { SalesOffer } from '../components/sales-offer'

export const SalesOffersPage: React.FC = () => <SalesOffer />
